module.exports = __webpack_public_path__ + "static/media/index-shop-2.4020a784.webp";